import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Chip, CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Api from '../../lib/Api';
import { classes } from './styles';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);
dayjs.extend(isToday);

function ActivityFeed() {
  const [activityList, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [finished, setFinished] = useState(false);

  async function getActivities(prevId) {
    setLoading(true);
    const response = await Api.getActivities(prevId);

    if (response[0]) {
      setList([...activityList, ...response]);
    } else {
      setFinished(true);
    }

    setLoading(false);
  }

  function checkScroll(evt) {
    if (loading || finished) return;
    if ((evt.target.scrollTop + evt.target.clientHeight) < (evt.target.scrollHeight - 50)) return;

    const lastDate = activityList[activityList.length - 1];
    const lastActivity = lastDate.activities[lastDate.activities.length - 1];
    getActivities(lastActivity.id)
  }

  useEffect(() => {
    getActivities();
  }, []);

  if (activityList[0]) activityList[0].isToday = dayjs(activityList[0].date).isToday();

  return (
    <Box mb={2}>
      <Accordion defaultExpanded sx={classes.accordian}>
        <AccordionSummary
          sx={classes.accordianButton}
          expandIcon={<ExpandMoreIcon sx={{ color: '#ffffff' }} />}
        >
          <Typography sx={classes.accordianTitle}>
            Activity Feed
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={classes.activitiesContainer}
          onScroll={checkScroll}
        >
          {activityList.map(({ date, activities, isToday }) => (
            <Box py={2} key={date} width="100%">
              <Box sx={classes.dateContainer}>
                <Chip
                  size="small"
                  label={isToday ? 'Today' : dayjs(date).format('LL')}
                  sx={classes.chip}
                />
              </Box>
              {activities.map(({ id, timestamp, actor, activity_html }) => (
                <Box key={id} py={1} >
                  <Typography sx={classes.timeStamp}>
                    {isToday ? (
                      dayjs().to(dayjs(timestamp))
                    ) : (
                      dayjs(timestamp).format('LT')
                    )}
                  </Typography>
                  <Typography sx={classes.actor}>
                    {actor}
                  </Typography>
                  <Typography
                    dangerouslySetInnerHTML={{ __html: activity_html }}
                    sx={classes.activity}
                  />
                </Box>
              ))}
            </Box>
          ))}
          {loading && (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default ActivityFeed;
